import { CheckboxFormField } from '@/components/shared/components/NewContextForms/CheckboxFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

interface ConfirmationCheckboxProps {
  label: string;
  fieldVariant?: FieldVariant;
}

export const ConfirmationCheckbox = ({ label, fieldVariant }: ConfirmationCheckboxProps) => {
  return (
    <CheckboxFormField
      name={'confirmation'}
      label={label}
      fieldVariant={fieldVariant}
      labelProps={{ forceSingleLine: false }}
    />
  );
};
